import React from 'react';

import './styles.css';

import { useSelector } from 'react-redux';

import HomeSlider from '../../partials/HomeSlider/HomeSlider.js'
import HomeIntro from '../../partials/HomeIntro/HomeIntro.js'
import HomeFeatured from '../../partials/HomeFeatured/HomeFeatured.js'
import HomeParallaxSection from '../../partials/HomeParallaxSection/HomeParallaxSection.js'

import FancyBoxGallery from '../../partials/FancyBoxGallery/FancyBoxGallery.js'
import Divisions from '../../partials/Divisions/Divisions.js'

import SEO from '../../partials/SEO/SEO.js'

const Home = props => {

    const { setting, loading, error } = useSelector((state) => state.settingStore);

    return (
        <React.Fragment>
        <SEO 
            title = {setting?.home_seo_title}
            description = {setting?.home_seo_description}
            keywords = {setting?.home_seo_keywords}
        />
        <div role="main" className="main">
                <HomeSlider />
                <Divisions />            
                <HomeIntro setting={setting} />
                <HomeFeatured setting={setting} />            
                <FancyBoxGallery setting={setting} />            
            </div>
        </React.Fragment>
    );
};

export default Home;
